import { module } from 'modujs'
import { debounce } from '../utils/tickers'

export default class extends module {
  constructor(m) {
    super(m)

    this.events = { click: { toggle: 'toggleContent' } }

    this.resizeCollapsesContents()

    this.resizeCallback = debounce(
      () => {
        this.resizeCollapsesContents()
      },
      10,
      false
    )

    window.addEventListener('resize', this.resizeCallback)
  }

  enter(e) {
    if (e.way === 'enter') {
      const id = e.target.getAttribute('data-index')
      const item = this.el.querySelector(`.c-how_item[data-index="${id}"]`)

      if (this.el.querySelectorAll('.c-how_item.-opened').length > 0 && !item.classList.contains('-opened')) {
        this.close(this.el.querySelector('.c-how_item.-opened'))
      }

      this.open(item)
    }
  }

  open(collapse) {
    const chart = collapse.querySelector('.c-how_item_datas_chart')

    if (chart) {
      setTimeout(() => {
        this.call(
          'play',
          null,
          'Chart',
          chart.getAttribute('data-module-chart')
        )
      }, 300)
    }

    collapse.classList.add('-opened')
  }

  close(collapse) {
    const chart = collapse.querySelector('.c-how_item_datas_chart')

    if (chart) {
      this.call(
        'reset',
        null,
        'Chart',
        chart.getAttribute('data-module-chart')
      )
    }

    collapse.classList.remove('-opened')
  }

  resizeCollapsesContents() {
    if (this.el.querySelectorAll('[data-collapse-opened]')) {
      this.el.querySelectorAll('[data-collapse-opened]').forEach((collapse) => {
        const contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight

        collapse.querySelector('[data-collapse-content]').style.height = `${contentHeight}px`
      })
    }

    if (this.el.querySelectorAll('.c-how_item_datas_left_content')) {
      this.el.querySelectorAll('.c-how_item_datas_left_content').forEach((c) => {
        const h1 = c.querySelector('.c-how_item_datas_left_content_txt.-default').offsetHeight
        const h2 = c.querySelector('.c-how_item_datas_left_content_txt.-active').offsetHeight

        c.style.height = `${Math.max(h1, h2)}px`
      })
    }
  }

  toggleContent(e) {
    const target = e.currentTarget
    const type = target.getAttribute('data-type')
    const wrap = target.closest('.c-how_item')

    target.classList.toggle('-active')
    wrap.classList.toggle('-active')

    if (wrap.classList.contains('-active')) {
      this.call(
        'play',
        null,
        'Chart',
        `${type}_with`
      )
    }
    else {
      this.call(
        'reset',
        null,
        'Chart',
        `${type}_with`
      )
    }
  }

  destroy() {
    window.removeEventListener('resize', this.resizeCallback)
  }
}
